module.exports = __webpack_public_path__ + "static/media/purpleCircle.f6257556.svg";